export default __webpack_public_path__ + "static/media/movie2.717aa8eb.png";